<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Bulk Allocation</strong> 

          </div>




          <b-row class="mt-2 mb-2">          
      
              <b-col md="6">
                <b-col sm="12" >
                   <b-form-group label="Delivery Agent From"  :label-cols="4" >
                    <b-form-select v-model="customer.deliveryagentmasterid" id="deliveryagent_from" name="deliveryagentname" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" v-on:change="getdeliveragentlistto();  ">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmasterid" v-for="customer in data1"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }}- {{ customer.deliveryagentmasterid }} </option>
                    </b-form-select> 
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>
                </b-col>

                    <b-col md="5">
                   <b-form-group label="Delivery Agent To"  :label-cols="4" >
                    <b-form-select v-model="customer1.deliveryagentmasterid" id="deliveryagent_to" name="deliveryagentname" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" v-on:change="setSelectedid()">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer1.deliveryagentmasterid" v-for="customer1 in data2"  :disabled="customer1.capacityforallocation== 0">{{ customer1.deliveryagentfirstname | capitalize }} {{ customer1.deliveryagentlastname | capitalize }} -{{ customer1.deliveryagentmasterid }} </option>
                    </b-form-select> 
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>

                


             


            
    </b-row> 





          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Assigned</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">OFD</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >NDR</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <bulkassigned style="width:70%;"></bulkassigned>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <bulkofd style="width:70%;"></bulkofd>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <bulkndr style="width:70%;" ></bulkndr>
            </div>
     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

import bulkassigned from './bulkassigned.vue'
import bulkofd from './bulkofd.vue'

import bulkndr from './bulkndr.vue'

export default {
  data: function() {
    return {
      activeTab: '',
      bulkassigned,
      bulkofd,
      id:'',
      customer: {},
      customer1:{},
      bulkndr,
      data1:[],
      data2:[],
     
     selected:'',




       
      
      name: 'bulkallocation'
     
    };
  },
  components: {
   

    bulkassigned,
    bulkofd,
   bulkndr
  },
 
  created: function() {
  
     //this.isActiveTab(1);
     this.getdeliveragentlistfrom();
   

  },
 
  methods: {
 getdeliveragentlistfrom: function() {
 
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
      
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.data1 = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    },

getshipmentCount: function() {

    var activeTab='';
    var activetabcount='';

    var deliveryagentmasterid=  document.getElementById('deliveryagent_from').value;

     
        const deliveryagent = {
      deliveryagentmasterid: `${deliveryagentmasterid}`,

      }
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DeliveryAgentMasterShipmentStatusCount`, deliveryagent)
        .then((result) => {

          this.activetabcount = result.body
         //console.log(this.activetabcount[0].bookingdone);

          if (this.activetabcount[0].ofd >0) {

            this.activeTab=2;
            this.isActiveTab(activeTab);

          }
          else if (this.activetabcount[0].handoverpending > 0) {
            this.activeTab=3;
            this.isActiveTab(activeTab);
          }
          else
          {
            this.activeTab=1;
            this.isActiveTab(activeTab);
          }
        })
      
   
            
      
      
    },


    getdeliveragentlistto: function() {

      var activeTab='';
      this.activeTab=0;
      this.isActiveTab(activeTab);


      // localStorage.setItem("deliveryagentmasterid", this.customer.deliveryagentmasterid);


     
      var userdata = localStorage.getItem('userData')

      var deliveryagentmasterid_from= document.getElementById('deliveryagent_from').value;

      //alert(deliveryagentmasterid_from);
      //localStorage.getItem('deliveryagentmasterid')
      var userInfo = JSON.parse(userdata)

      const deliveryagent = {
      deliveryagentmasterid: `${deliveryagentmasterid_from}`,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
      .then((result) => {

          this.isBusy = true;
        this.data2 = result.body;
          this.getshipmentCount();

      })
      .catch((ex) => {
        console.log('error', ex)
      })
      
    },


    
setSelectedid: function() { 

     //alert(this.customer1.deliveryagentmasterid); 
    localStorage.setItem("deliveryagentmasteridto", this.customer1.deliveryagentmasterid);
     var x=this.customer1.deliveryagentmasterid;
     // console.log(x); 
      },

  	isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
